module.exports = __webpack_public_path__ + "img/soda-can.e85772b0.png";